import AudioContext from './AudioContext';
import Instrument from './Instruments';
// import Melody from './Melody';
// import Musician from './Musician';
import Note from './Note';
import INSTRUMENT_NAMES from './constants/INSTRUMENTS';
import InstrumentHelpers from './helpers/';

export {
  AudioContext,
  Instrument,
  Note,
  INSTRUMENT_NAMES,
  InstrumentHelpers,
}



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/